import { createContext } from 'react';

export enum DeviceType {
  PC = 'PC',
  MOBILE = 'MOBILE',
}

const DeviceContext = createContext<DeviceType>(DeviceType.MOBILE);

export { DeviceContext };
